import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-map-delete',
    templateUrl: './map-delete.component.html',
    styleUrls: ['./map-delete.component.scss'],
    standalone: false
})
export class MapDeleteComponent {
    @Input() mapId: any;
    mapIds: any[];
    @Input() userId: any;
    @Output() deleted = new EventEmitter<boolean>();

    loading = false;
    error: string | null = null;

    // Confirmation Checkboxes
    confirmWorldMap = false;
    confirmWiki = false;
    confirmGames = false;
    confirmCharacters = false;

    constructor(
        public activeModal: NgbActiveModal,
        private dataService: DataService,
        private cdr: ChangeDetectorRef
    ) { }

    get canDelete(): boolean {
        return this.confirmWorldMap && this.confirmWiki && this.confirmGames && this.confirmCharacters;
    }

    confirmDelete() {
        this.loading = true;
        if (this.mapId) {
            this.dataService.deletemap(this.mapId, this.userId).subscribe({
                next: () => {
                    this.loading = false;
                    this.cdr.detectChanges();
                    this.deleted.emit(true);
                    this.activeModal.close('deleted');
                },
                error: err => {
                    this.loading = false;
                    this.error = 'Failed to delete map.';
                
          this.cdr.detectChanges();}
            });
        }

        else if (this.mapIds && Array.isArray(this.mapIds) && this.mapIds.length > 0) {

            forkJoin(this.mapIds.map(mapId => this.dataService.deletemap(mapId, this.userId))).subscribe({
                next: () => {
                    this.loading = false;
                    this.cdr.detectChanges();
                    this.deleted.emit(true);
                    this.activeModal.close('deleted');
                },
                error: err => {
                    this.loading = false;
                    this.error = 'Failed to delete map.';
                
          this.cdr.detectChanges();}
            });

        }
    }

    cancel() {
        this.activeModal.dismiss('cancel');
    }
}
